import { useEffect, useState } from "react";
import CardSwap, { Card } from "../blocks/Components/CardSwap/CardSwap";
import { motion, AnimatePresence } from "framer-motion";
import CTA from "../components/CTA";

const cardData = [
  {
    img: "/images/me.jpg",
    title: "Qui suis-je ?",
    desc: "Développeur curieux, passionné de création digitale et toujours prêt à relever de nouveaux défis. Mon objectif : transformer les idées en projets concrets, utiles et bien codés.",
  },
  {
    img: "/images/foot_am.jpg",
    title: "La rigueur du sport",
    desc: "Le sport m’a appris l’endurance, la discipline et le travail d’équipe. Des valeurs que j’applique chaque jour dans mes projets web comme dans la vie.",
  },
  {
    img: "/images/e-sport.jpg",
    title: "L’univers e-sport",
    desc: "Fan de l'écosystème e-sport, de la Karmine Corp et membre du BlueWall, j’y puise une énergie, une culture et une ambition qui m’inspirent au quotidien dans mes projets créatifs et tech.",
  },
];

const SwapCards = () => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  return (
    <section id="about" className="relative w-full px-10 pb-24 bg-black text-white">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
        {/* LEFT TEXT COLUMN */}
        <div className="flex flex-col gap-6 text-center lg:mt-0 mt-32 md:text-left relative min-h-[120px] max-w-md w-full">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentCardIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              className="absolute inset-0 flex flex-col gap-6"
            >
              <h2 className="text-4xl font-bold">{cardData[currentCardIndex].title}</h2>
              <p className="text-white-50 text-lg">{cardData[currentCardIndex].desc}</p>
              <CTA text="Me contacter" />
            </motion.div>
          </AnimatePresence>
        </div>

        {/* RIGHT 3D CARDS */}
        <div className="z-3" style={{ height: "800px", position: "relative", flexShrink: 0 }}>
          <CardSwap
            cardDistance={60}
            verticalDistance={70}
            delay={4000}
            pauseOnHover={false}
            onCardClick={(index) => setCurrentCardIndex(index)}
            onCardChange={setCurrentCardIndex}
          >
            {cardData.map((card, i) => (
              <Card key={i} data-id={i} className="overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover rounded-xl"
                />
              </Card>
            ))}
          </CardSwap>
        </div>
      </div>
    </section>
  );
};

export default SwapCards;
